export default __webpack_public_path__ + "static/media/IMG-20210326-WA0031.2dbdd486.jpg";